// src/pages/TpLink/TapoCameras/index.jsx
import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export default function TapoCameras() {
  return (
    <div className="min-h-screen bg-[#111111] text-white scroll-smooth">
      <Helmet>
        <title>Tapo Cameras | SeguraTech</title>
        <meta
          name="description"
          content="Explore TP-Link Tapo cameras including indoor and outdoor security solutions for your home or business."
        />
      </Helmet>

      {/* HERO */}
      <section className="max-w-5xl mx-auto px-4 py-20 text-center">
        <h1 className="text-4xl md:text-6xl font-extrabold text-[#C6A564] mb-6">
          TP-Link Tapo Cameras
        </h1>
        <p className="text-lg text-white/80 max-w-3xl mx-auto">
          Choose Indoor or Outdoor cameras to explore battery-powered and
          mains-powered models in each category.
        </p>
      </section>

      {/* CATEGORY SELECTION */}
      <section className="max-w-6xl mx-auto px-4 pb-24">
        <div className="grid md:grid-cols-2 gap-10">

          {/* Indoor Cameras */}
          <Link
            to="/tplink/cameras/indoor"
            className="border border-[#C6A564] rounded-2xl p-10 bg-[#1a1a1a] hover:bg-[#222222] transition block text-center"
          >
            <h2 className="text-3xl font-semibold text-[#C6A564] mb-4">
              Indoor Cameras
            </h2>
            <p className="text-white/80">
              Smart, discreet indoor cameras designed for modern homes — view
              our battery and mains-powered models.
            </p>
          </Link>

          {/* Outdoor Cameras */}
          <Link
            to="/tplink/cameras/outdoor"
            className="border border-[#C6A564] rounded-2xl p-10 bg-[#1a1a1a] hover:bg-[#222222] transition block text-center"
          >
            <h2 className="text-3xl font-semibold text-[#C6A564] mb-4">
              Outdoor Cameras
            </h2>
            <p className="text-white/80">
              Weather-resistant outdoor cameras for gardens, driveways, and
              exteriors — battery or mains options available.
            </p>
          </Link>
        </div>
      </section>

      {/* BACK LINK */}
      <div className="text-center pb-16">
        <Link
          to="/tplink"
          className="text-[#C6A564] hover:text-[#E7D7B0] transition underline"
        >
          ← Back to TP-Link Overview
        </Link>
      </div>
    </div>
  );
}
